export const noop = () => void 0;

/**
 * Exibe um aviso apenas fora do ambiente de produção.
 *
 * @param {unknown} message
 * @param {...unknown} args
 * @returns {void}
 */
export function dispatchWarn(message, ...args) {
  if (process.env.NODE_ENV !== "production") {
    console.warn(message, ...args);
  }
}
